import React, { Component, Fragment } from "react";
import {NavLink , withRouter } from "react-router-dom";
import style from "../employer.css";
import AppContext from "../../../contexts/AppContext";


export class AccountNav extends Component {
    state = {       
        accountnav: window.screen.width >= 1280 ? true : false,           
    };
    toggleAccountNav()
    {
        this.setState({ accountnav: this.state.accountnav === true ? false : true });
    }
    render() {
        return (
            <Fragment>
                <a to="#" onClick={() => this.toggleAccountNav()} id="mobile-nav-dashboard">
                    Dashboard
                </a>
                
                <nav className={this.state.accountnav ? `navbar open`: `navbar`}>
		            <ul className="nav navbar-nav">
		        	    <li>
		        		    <NavLink
                                activeClassName='active'
                                className="nav-link"
                                to={`/employer/account`}
	                            exact={true}
                            >
                                Dashboard
                            </NavLink>
						</li>
		        		<li>
		        		    <NavLink
                                activeClassName='active'
                                className="nav-link"
                                to={`/employer/jobListing`}
								// exact={true}
                            >
                                Listings
                            </NavLink>
		        		</li>
		        		<li>
		        		    <NavLink
                                activeClassName='active'
                                className="nav-link"
                                to={`/employer/applicants`}
								// exact={true}
                            >
                                Applicants
                            </NavLink>
		        		</li>
		        		<li>
		        		    <NavLink
                                activeClassName='active'
                                className="nav-link"
                                to={`/employer/jobs`}
								exact={true}
                            >
                               My Jobs
                            </NavLink>
		        		</li>
                        <li>
		        		    <NavLink
                                activeClassName='active'
                                className="nav-link"
                                to={`/employer/writers`}
								exact={true}
                            >
                                My Writers
                            </NavLink>
		        		</li>
		        		
		        		{/* <li>
		        		    <NavLink
                                activeClassName='active'
                                className="nav-link"
                                to={`/employer/notifications`}
								exact={true}
                            >
                                Notifications
                            </NavLink>
		        		</li>
		        		<li>
		        		    <NavLink
                                activeClassName='active'
                                className="nav-link"
                                to={`/employer/settings`}
								// exact={true}
                            >
                                Settings
                            </NavLink>
		        		</li> */}
		        	</ul>
		        </nav>
               
            </Fragment>
        );
    }
}
AccountNav.contextType = AppContext;

export default withRouter(({ location, ...props }) => {
    return <AccountNav {...props}   />;
 });


// WEBPACK FOOTER //
// ./src/components/employer/account/AccountNav.js